import { render, staticRenderFns } from "./LocaleDateTime.vue?vue&type=template&id=567f7dfc&"
import script from "./LocaleDateTime.vue?vue&type=script&lang=js&"
export * from "./LocaleDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports